var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  width: 30px;\n  height: 30px;\n  background-image: url(" + escape(require("./img/ajax-loader.gif")) + ");\n  background-repeat: no-repeat;\n  background-position: center center;\n}\n\n.hide {\n  display: none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/viega-common/components/loading-spinner/loading-spinner.component.scss
// module id = 9p6r
// module chunks = 5